import React from 'react'

import { FieldValues } from 'react-hook-form'

import { MaskedInputField, type MaskedInputFieldProps } from './MaskedInputField'

interface CivilIDFieldProps<T extends FieldValues> extends Omit<MaskedInputFieldProps<T>, 'mask' | 'onValue'> {
  maskFormat?: string
}

export function CivilIDField<T extends FieldValues>({ maskFormat = '9999-9999-9999', ...props }: CivilIDFieldProps<T>) {
  return (
    <MaskedInputField
      {...props}
      mask={maskFormat}
      onValue={(val) => val.replace(/\D/g, '')}
      inputProps={{
        maxLength: 14, // 12 digits + 2 dashes
        ...props.inputProps,
      }}
    />
  )
}

// Memoized version for better performance
export const MemoizedCivilIDField = React.memo(CivilIDField) as typeof CivilIDField
